import type { JSX } from 'react'

import { Icon, IconNames } from 'atoms/Icon'
import { IconSocialSizes } from 'atoms/Icon/Icon.h'
import { TextBoxMaxLine1Body4Secondary } from 'atoms/TextBox/Templates'
import { IconsGroupSC, SocialLinksSC } from '../Footer.styled'

export interface ISocialLinks {
  title?: string
  appStoreLink?: string
  googlePlayLink?: string
  amazonStoreLink?: string
}

export const SocialLinks = ({
  title = '',
  appStoreLink,
  googlePlayLink,
  amazonStoreLink,
}: ISocialLinks): JSX.Element | null => {
  const condition = amazonStoreLink || appStoreLink || googlePlayLink

  return condition ? (
    <SocialLinksSC>
      <TextBoxMaxLine1Body4Secondary title={title} />
      <IconsGroupSC>
        {appStoreLink && (
          <a href={appStoreLink} target='_blank' rel='noreferrer'>
            <Icon name={IconNames.appStore} size={IconSocialSizes.appStore} />
          </a>
        )}
        {googlePlayLink && (
          <a href={googlePlayLink} target='_blank' rel='noreferrer'>
            <Icon
              name={IconNames.googlePlay}
              size={IconSocialSizes.googlePlay}
            />
          </a>
        )}
        {amazonStoreLink && (
          <a href={amazonStoreLink} target='_blank' rel='noreferrer'>
            <Icon
              name={IconNames.amazonStore}
              size={IconSocialSizes.googlePlay}
            />
          </a>
        )}
      </IconsGroupSC>
    </SocialLinksSC>
  ) : null
}
